/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file ProteinuriaView.jsx
 * @author Daniel Aguirre
 * @description Proteinuria View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * Proteinuria View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function ProteinuriaView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getProteinuria } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'P1',
        color: styleGuideColors.baxterBrandTeal
      },
      {
        label: 'P2',
        color: styleGuideColors.baxterBrandBaxterBlue
      },
      {
        label: 'P3',
        color: styleGuideColors.graphYellow
      },
      {
        label: 'P4',
        color: styleGuideColors.alertError
      },
      {
        label: 'Sin Registros',
        color: styleGuideColors.graphGreyStrokes
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, color }) => {
        const respElement = resp.data.find(
          ({ clasificacion }) => clasificacion === label
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label: translate(`dashboardStaff.${label}`),
              classification: respElement.clasificacion,
              color,
              cantidad: respElement.cantidad
            }
          ];
        }
      });
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    getProteinuria({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (data) => {
    const { classification, cantidad } = chartData[data];
    history.push(
      `/main/dashboard-detail/proteinuria/${classification}/${cantidad}`
    );
  };

  return (
    <DashboardCard id="F15" loading={!chartData}>
      <DashboardDoughnut
        title={'Proteinuria (24h)'}
        dataValues={chartData}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
ProteinuriaView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getProteinuria: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default ProteinuriaView;
